module.exports = __webpack_public_path__ + "static/time-axis-with-irregular-intervals-02661e3cd9bbc594c34c2933f4ae1bd4.png";